/**
 * scheduleManagement模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const scheduleManagement = {
  // 创建日程
  createSchedule(params) {
    return $http.post(`${global.API_URL}/sme/scheduleManagement/create`,params);
  },
  // 更新定时任务
  updateSchedule(params) {
    return $http.post(`${global.API_URL}/sme/scheduleManagement/update`,params);
  },
  //日程列表分页
  pageScheduleManagement(params) {
    return $http.post(`${global.API_URL}/sme/scheduleManagement/page`,params);
  },
  //日程删除
  deleteSchedule(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/scheduleManagement/delete`,param);
  },
  //查询日程
  querySchedulesByUserName(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/scheduleManagement/querySchedulesByUserName`,param);
  }
}

export default scheduleManagement;



// WEBPACK FOOTER //
// ./src/api/scheduleManagement.js